<template>
  <SeasonLeaderboardList
    :style="{ maxHeight: !$device.isMobile ? '50vh' : 'auto', paddingTop: '10px' }"
    :is-jackpot="true"
  />
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped></style>
